module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.filters.name = $$v
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "联系方式"
    },
    model: {
      value: (_vm.filters.phone),
      callback: function($$v) {
        _vm.filters.phone = $$v
      },
      expression: "filters.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择组别"
    },
    model: {
      value: (_vm.filters.group),
      callback: function($$v) {
        _vm.filters.group = $$v
      },
      expression: "filters.group"
    }
  }, _vm._l((_vm.groupOptions), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.groupName,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getPageUsers(1)
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.formattedUsers,
      "height": "500"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-form', {
          staticClass: "user-table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "姓名"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.name))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "工号"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.number))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "微信ID"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.wxId))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "联系方式"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.phone))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "邮箱"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.email))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "角色"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.formattedRole))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "权限"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.formattedAuthority.join('，')))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "组别"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.formattedGroup))])])], 1)]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "formattedRole",
      "label": "角色"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "formattedAuthority",
      "label": "权限"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.formattedAuthority.join('，')))])]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "formattedGroup",
      "label": "组别"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleDel(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }]
    ])
  })], 1)], _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.getPageUsers
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editFormTtile
    },
    on: {
      "close": _vm.resetForm
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "100px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.editForm.name = $$v
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工号",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.number),
      callback: function($$v) {
        _vm.editForm.number = $$v
      },
      expression: "editForm.number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "微信ID",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.wxId),
      callback: function($$v) {
        _vm.editForm.wxId = $$v
      },
      expression: "editForm.wxId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话",
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.phone),
      callback: function($$v) {
        _vm.editForm.phone = $$v
      },
      expression: "editForm.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.email),
      callback: function($$v) {
        _vm.editForm.email = $$v
      },
      expression: "editForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "组别",
      "prop": "group"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择组别"
    },
    model: {
      value: (_vm.editForm.group),
      callback: function($$v) {
        _vm.editForm.group = _vm._n($$v)
      },
      expression: "editForm.group"
    }
  }, _vm._l((_vm.groupOptions), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.groupName,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角色",
      "prop": "role"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.editForm.role),
      callback: function($$v) {
        _vm.editForm.role = _vm._n($$v)
      },
      expression: "editForm.role"
    }
  }, _vm._l((_vm.roleOptions), function(item) {
    return _c('el-radio', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.label) + "\n          ")])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editForm.role === 1),
      expression: "editForm.role === 1"
    }],
    attrs: {
      "label": "权限",
      "prop": "authority"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.editForm.authority),
      callback: function($$v) {
        _vm.editForm.authority = $$v
      },
      expression: "editForm.authority"
    }
  }, _vm._l((_vm.authorityOptions), function(item) {
    return _c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.label) + "\n          ")])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editForm.role === 1),
      expression: "editForm.role === 1"
    }],
    attrs: {
      "label": "全局权限"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-color": "#13ce66",
      "off-color": "#ff4949"
    },
    model: {
      value: (_vm.editForm.isAllAuthorityRange),
      callback: function($$v) {
        _vm.editForm.isAllAuthorityRange = $$v
      },
      expression: "editForm.isAllAuthorityRange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editForm.role === 1 && _vm.editForm.isAllAuthorityRange === false),
      expression: "editForm.role === 1 && editForm.isAllAuthorityRange === false"
    }],
    attrs: {
      "label": "选择设备"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, _vm._l((_vm.selectedDevicesTags), function(tag) {
    return _c('el-tag', {
      key: tag.id,
      attrs: {
        "closable": true,
        "type": "primary"
      },
      on: {
        "close": function($event) {
          _vm.selectedDeviceClose(tag)
        }
      }
    }, [_vm._v(_vm._s(tag.deviceName))])
  })), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.deviceFilters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "设备名",
      "size": "small"
    },
    model: {
      value: (_vm.deviceFilters.deviceName),
      callback: function($$v) {
        _vm.deviceFilters.deviceName = $$v
      },
      expression: "deviceFilters.deviceName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.getPageDevices(1)
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.formattedDevices
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "40"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "设备编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deviceName",
      "label": "设备名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "formattedAdministrator",
      "label": "设备管理员"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "small": "",
      "layout": "prev, pager, next",
      "current-page": _vm.devicesPage,
      "page-size": _vm.devicesPageSize,
      "total": _vm.devicesTotal
    },
    on: {
      "current-change": _vm.getPageDevices
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.editSubmit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.btnEditText))])], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ec0d7fb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/user.vue
// module id = 532
// module chunks = 1